<template>
    <div class="container">
        <b-container fluid v-if="!showPage">
              <b-row>
                <div class="text-center m-5">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>&nbsp;Loading...</strong>
                </div>
              </b-row>
        </b-container>   
        <b-container fluid v-if="showPage" style="margin-top:100px;">
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h3>Project: <a v-bind:href="'https://www.ncbi.nlm.nih.gov/bioproject/'+projId" target="_blank">{{this.projId}}  &nbsp; <font-awesome-icon icon="external-link-alt" size='sm'></font-awesome-icon></a></h3>
                </b-col>
            </b-row>            
            <b-row>
                <b-col align-self="center">
                    <hr>                    
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <ul>
                        <li><b>Project ID:</b> {{this.projId}}</li>
                        <li><b>Project details:</b>{{this.projInfo.OriginalProjectDescription}}</li>
                        <li><b>Total Number of runs:</b> <span style="color:red;font-weight: bold;">{{this.projInfo.NumberOfRuns}}</span></li>
                        <li><b>Number of samples:</b> <span style="color:red;font-weight: bold;">{{this.projInfo.NumberOfSamples}}</span></li>
                    </ul>
                </b-col>
            </b-row>
            <b-row v-if="showPlot">
                <b-col>
                    <Plotly :data="barPlotDat" :layout="retLayout" :autoResize="true"></Plotly>
                </b-col>
            </b-row>
            <br>
            <b-row style="text-align: left;">
                <b-col>
                    <h3>Associated runs</h3>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <hr>
                    <b-table
                        responsive
                        show-empty
                        :busy.sync="samIsBusy"
                        :striped="false"
                        :outlined="true"
                        :items="samples_data"
                        :fields="sample_fields"
                        :current-page="currentPage"
                        :per-page="perPage"
                    >
                        <template  v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </template>
                        <template v-slot:cell(NCBI_Run_ID) ="row">
                                <router-link :to="{ path: '/viewsample/'+row.item.NCBI_Run_ID.trim()}" target="_blank" v-b-tooltip.hover title="View Project details in our database">{{row.item.NCBI_Run_ID.trim()}} <font-awesome-icon icon="link" size='sm'></font-awesome-icon></router-link>
                                <b-badge id="badge-tar" variant="primary"><a v-bind:href="'https://trace.ncbi.nlm.nih.gov/Traces/sra/?run=' + row.item.NCBI_Run_ID.trim()" target="_blank" style="color:white">NCBI <font-awesome-icon icon="external-link-alt" size='sm'></font-awesome-icon></a></b-badge>
                        </template>
                        <template v-slot:cell(Sex)="row">
                            <span v-if="row.item.Sex.length >= 1">
                               {{row.item.Sex}}
                           </span>
                           <span v-else>
                               NA
                           </span>
                        </template>
                        <template v-slot:cell(HostAge)="row">
                           <span v-if="row.item.HostAge.length >= 1">
                               {{row.item.HostAge}}
                           </span>
                           <span v-else>
                               NA
                           </span>
                        </template>
                        <template v-slot:cell(geo_location)="row">
                            Long:{{row.item.GeoLongitude}},Lat:{{row.item.GeoLatitude}}
                        </template>
                        <template v-slot:cell(Original_Sample_Description)="row">
                                <read-more more-str="read more" :text="row.item.Original_Sample_Description" link="#" less-str="read less" :max-chars="100" style="text-align:justify"></read-more>
                        </template>
                    </b-table>
                    <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="currentPage"
                                :total-rows="totalSamRows"
                                :per-page="perPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data () {
        return{
            server_add:"https://mai.fudan.edu.cn/",
            showPage:true,
            filter:null,
            samIsBusy:true,
            samples_data:[],
            sample_fields:[
                { key:'NCBI_Run_ID',label:'Run ID',sortable:false,'class': 'medium_col' },
                { key: 'NCBI_Sample_ID', label: 'Sample ID', sortable: false },
                { key: 'InstrumentModel', label: 'Intrument model', sortable: false},
                { key: 'BodySite', label: 'Site', sortable: false},
                { key: 'Country', label: 'Country', sortable: false},
                { key: 'HostAge', label: 'Age', sortable: false},
                { key: 'Sex', label: 'Gender', sortable: false},
                { key: 'geo_location', label: 'Geo location', sortable: false},
                { key: 'Phenotype', label: 'Phenotype', sortable: false },
                // { key: 'Original_Sample_Description', label: 'Description', sortable: false},
            ],
            totalSamRows: 1,
            currentPage: 1,
            perPage: 15,
            pageOptions: [5, 10, 15,25],
            projId:'',
            projInfo:'',
            barPlotDat:[],
            retLayout:{
                title:'MGE distribution across runs',
                barmode:'stack'
            },
            showPlot:false,
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init(){
            this.projId = this.$route.params.projid
            this.importProjDet()
            this.importSampleList()
            this.importGraphData()
        },
        importProjDet(){
            axios.post(this.server_add+'query/getProj',
            {
                projId:this.projId
            }).then(retDat => {
                if(retDat.status == 200){
                    this.projInfo = retDat.data
                    console.log(this.projInfo)
                }else{
                    console.log('no proj related data for ',this.projId)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        importSampleList(){
            axios.post(this.server_add+'query/listProjSamples',
            {
                projId:this.projId
            }).then(retDat => {
                if(retDat.status == 200){
                    this.samples_data = retDat.data
                    this.samIsBusy = false
                    this.totalSamRows = this.samples_data.length
                }
            }).catch(err => {
                console.log(err)
            })
        },
        importGraphData(){
            axios.post(this.server_add+'query/listProjSamplesMges',
            {
                projId:this.projId
            }).then(retDat => {
                if(retDat.status == 200 && retDat.data != 'error:no mge found'){
                    var graphDat = retDat.data
                    for(var key in graphDat){
                        // console.log(key,graphDat[key])
                        var trace1 = {
                            x: graphDat[key].x,
                            y: graphDat[key].y,
                            name: key,
                            type: 'bar'
                        };
                        this.barPlotDat.push(trace1)
                        this.showPlot = true
                    }                    
                }
            }).catch(err => {
                console.log(err)
            })
        },
    },
}
</script>

<style lang="less">
    #boxBg{
    background-color: #ECE9E9;
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 5px;
    align-content: left;
    color: black;
}

.medium_col{
  width: 140px !important;
  height: 25px !important;
  max-height: 25px !important;
  max-width: 140px !important;
  text-align: center;
}
</style>